import { commonRoutes } from 'components/layout/commonRoutes'
import { mergeAllUrls } from 'functions/mergeAllUrls'

export const unauthorizedRoutes = [...commonRoutes]
export const pathsWithMambaLayout = unauthorizedRoutes.map(({ path }) =>
  mergeAllUrls(path.split('/').filter((path) => path)[0])
)

export const allInnerRoutes = [...commonRoutes]
